import React, { useState } from 'react';
import './OutdoorToggle.css';

function loadOutdoor() {
  try { return localStorage.getItem('tmg_outdoor') === '1'; } catch { return false; }
}

function saveOutdoor(v) {
  try { localStorage.setItem('tmg_outdoor', v ? '1' : '0'); } catch { /* ignore */ }
}

export function useOutdoorMode() {
  const [outdoor, setOutdoor] = useState(loadOutdoor);

  function toggleOutdoor() {
    setOutdoor(prev => {
      const next = !prev;
      saveOutdoor(next);
      return next;
    });
  }

  return { outdoor, toggleOutdoor };
}

export default function OutdoorToggle({ outdoor, onToggle }) {
  return (
    <button
      className={`outdoor-toggle-pill${outdoor ? ' outdoor-active' : ''}`}
      onClick={onToggle}
      title={outdoor ? 'Switch to indoor mode' : 'Switch to outdoor mode'}
    >
      {outdoor ? 'INDOOR' : 'OUTDOOR'}
    </button>
  );
}
